import { IJxtWorkplaceDay, IJxtWorkplaceHalfDay, JxtWorkplaceTypeEnum } from './types';

export const disableIJxtWorkplaceHalfDay = (workplaceHalfDay: IJxtWorkplaceHalfDay) => {
  return workplaceHalfDay.type === JxtWorkplaceTypeEnum.Unknown
    ? !workplaceHalfDay.capabilities.create
    : !workplaceHalfDay.capabilities.update;
};

export const disableIJxtWorkplaceDayReset = (workplaceDay: IJxtWorkplaceDay) => {
  return !workplaceDay.morning.capabilities.cancel && !workplaceDay.afternoon.capabilities.cancel;
};

/** Something can be done in its editor (a past day: nothing, but for an admin, as the server says). */
export const canEditIJxtWorkplaceDay = (workplaceDay: IJxtWorkplaceDay) =>
  !disableIJxtWorkplaceHalfDay(workplaceDay.morning) ||
  !disableIJxtWorkplaceHalfDay(workplaceDay.afternoon) ||
  !disableIJxtWorkplaceDayReset(workplaceDay);
